var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoCcimp(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "r\xE8gles",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 217 65.75",
    style: {
      enableBackground: "new 0 0 217 65.75"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M64.411,22.956V22.02c0-4.55,1.508-7.8,7.046-7.8c4.16,0,6.032,1.742,6.5,5.564l-3.536,0.52 c-0.13-2.002-0.962-3.198-3.042-3.198c-2.834,0-3.666,1.846-3.666,4.914v0.936c0,3.328,0.858,4.914,3.718,4.914 c2.236,0,2.912-0.962,3.173-3.406l3.51,0.39c-0.624,3.615-2.34,5.876-6.942,5.876C65.997,30.73,64.411,27.455,64.411,22.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M79.257,22.956V22.02c0-4.55,1.508-7.8,7.046-7.8c4.16,0,6.032,1.742,6.5,5.564l-3.536,0.52 c-0.13-2.002-0.962-3.198-3.042-3.198c-2.834,0-3.666,1.846-3.666,4.914v0.936c0,3.328,0.858,4.914,3.718,4.914 c2.236,0,2.912-0.962,3.173-3.406l3.51,0.39c-0.624,3.615-2.34,5.876-6.942,5.876C80.843,30.73,79.257,27.455,79.257,22.956z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M94.935,14.35h3.275v16.277h-3.275V14.35z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M105.543,16.232h4.116l3.173,9.864l3.15-9.864h4.116v14.395h-2.897v-9.613l-3.127,9.613h-2.645 l-3.128-9.567v9.567h-2.759V16.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M126.448,16.117h2.943l4.898,14.51h-2.92l-0.989-2.898h-4.989l-0.966,2.898h-2.829L126.448,16.117z  M126.172,25.407h3.427l-1.725-5.082L126.172,25.407z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M141.488,24.969h-2.805v5.658h-2.898V16.232h6.277c2.553,0,4.99,0.735,4.99,4.3 c0,2.254-1.196,3.472-2.668,4.024l2.897,6.071h-3.104L141.488,24.969z M141.695,22.579c1.633,0,2.461-0.575,2.461-2.001 c0-1.334-0.782-1.954-2.461-1.954h-3.012v3.955H141.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M148.275,26.303l3.105-0.321c0.299,1.472,0.966,2.231,3.196,2.231c1.656,0,2.736-0.438,2.736-1.749 c0-1.311-1.173-1.541-3.31-2.023c-2.645-0.575-5.06-1.196-5.06-4.254c0-2.276,1.518-4.07,5.542-4.07 c3.196,0,4.967,1.311,5.588,3.794l-3.196,0.414c-0.231-1.127-0.874-1.655-2.392-1.655c-1.932,0-2.621,0.506-2.621,1.472 c0,1.012,0.896,1.287,2.989,1.771c3.38,0.759,5.381,1.448,5.381,4.576c0,2.85-2.529,4.254-5.68,4.254 C150.276,30.742,148.896,28.902,148.275,26.303z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M162.121,16.232h9.772v2.552h-6.875v2.783h6.186v2.506h-6.186v4.025h6.875v2.529h-9.772V16.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M174.241,16.232h2.897v14.395h-2.897V16.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M179.83,16.232h2.897v11.866h6.554v2.529h-9.451V16.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M190.917,16.232h2.897v11.866h6.554v2.529h-9.451V16.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M202.003,16.232h9.773v2.552H204.9v2.783h6.186v2.506H204.9v4.025h6.875v2.529h-9.773V16.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M65.011,36.232h6.277c2.438,0,4.99,0.713,4.99,4.346c0,3.219-2.392,4.576-4.99,4.576h-3.38v5.473 h-2.897V36.232z M70.92,42.785c1.403,0,2.461-0.438,2.461-2.092c0-1.611-0.943-2.07-2.461-2.07h-3.012v4.162H70.92z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M83.685,44.969H80.88v5.658h-2.897V36.232h6.277c2.553,0,4.99,0.734,4.99,4.299 c0,2.254-1.196,3.473-2.668,4.025l2.897,6.07h-3.104L83.685,44.969z M83.892,42.578c1.633,0,2.461-0.574,2.461-2 c0-1.334-0.782-1.955-2.461-1.955H80.88v3.955H83.892z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M90.724,43.844v-0.828c0-3.771,1.265-6.898,6.209-6.898c4.99,0,6.231,3.08,6.231,6.828v0.875 c0,3.473-1.494,6.898-6.231,6.898C92.241,50.719,90.724,47.568,90.724,43.844z M100.244,43.889v-0.92 c0-3.035-0.943-4.299-3.312-4.299c-2.346,0-3.288,1.287-3.288,4.322v0.873c0,3.014,1.149,4.369,3.288,4.369 C99.094,48.234,100.244,46.9,100.244,43.889z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M111.698,50.742h-2.92l-4.807-14.51h2.897l3.403,10.576l3.403-10.576h2.829L111.698,50.742z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M118.001,36.232h9.772v2.551h-6.875v2.783h6.186v2.506h-6.186v4.025h6.875v2.529h-9.772V36.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M130.075,36.232h3.472l4.968,8.943v-8.943h2.805v14.395h-2.852l-5.61-10.072v10.072h-2.782V36.232z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M143.276,43.844v-0.828c0-4.025,1.334-6.898,6.232-6.898c3.679,0,5.334,1.541,5.748,4.92 l-3.127,0.461c-0.115-1.771-0.851-2.828-2.69-2.828c-2.507,0-3.242,1.631-3.242,4.346v0.828c0,2.943,0.759,4.346,3.288,4.346 c1.977,0,2.575-0.852,2.806-3.014l3.104,0.346c-0.553,3.197-2.07,5.197-6.14,5.197C144.68,50.719,143.276,47.82,143.276,43.844z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M157.1,36.232h9.772v2.551h-6.875v2.783h6.186v2.506h-6.186v4.025h6.875v2.529H157.1V36.232z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M6.951,33.484c0,14.066,11.445,25.51,25.511,25.51c6.699,0,11.978-2.521,15.684-5.414l-5.38-6.01 c-2.96,2.13-6.419,3.335-10.304,3.335c-9.606,0-17.423-7.816-17.423-17.421S22.855,16.06,32.461,16.06 c2.487,0,4.846,0.535,6.987,1.476l3.204-7.433c-3.124-1.362-6.568-2.132-10.19-2.132C18.395,7.972,6.951,19.42,6.951,33.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#004379"
    },
    d: "M18.863,33.484c0,7.496,6.098,13.595,13.598,13.595c2.873,0,5.778-1.022,7.642-2.421 c0,0-5.053-5.636-5.496-6.117c-0.454,0.219-1.367,0.444-2.146,0.444c-3.035,0-5.508-2.465-5.508-5.501 c0-3.036,2.492-5.585,5.527-5.585c0.783,0,1.56,0.183,2.241,0.482l3.195-7.323c-1.624-0.688-3.426-1.173-5.454-1.173 C24.961,19.886,18.863,25.988,18.863,33.484z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E50043"
    },
    d: "M42.601,28.196c0.699,1.378,1.311,3.271,1.311,5.288c0,2.545-1.074,5.309-2.508,7.146l5.459,6.015 c3.042-3.251,5.136-7.977,5.136-13.161c0-3.072-0.765-6.16-2.056-8.712L42.601,28.196z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E50043"
    },
    d: "M40.338,25.18l13.853-6.493c-2.048-3.009-4.84-5.753-7.691-7.477l-6.206,13.928L40.338,25.18z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoCcimp);
export default __webpack_public_path__ + "static/media/logo_CCIMP.9341ca7a191acfa3ff5fef254414f7dd.svg";
export { ForwardRef as ReactComponent };